import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import {
  applyStylesForScreenSize,
  SCREEN_SIZES,
} from 'brand-guidelines/utils/screenSizeUtils';

export const SecureWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const SecureText = styled.span`
  ${TYPOGRAPHY.CIRCULAR.bold};
  white-space: nowrap;
  color: ${BRAND_COLORS.darkGray};
  text-align: center;
  font-size: 14px;
  font-style: normal;

  ${applyStylesForScreenSize(
    [SCREEN_SIZES.PHONE],
    css`
      font-size: 12px;
      line-height: 22px;
    `,
  )}
`;
